import { getCurrentReinsuranceYear } from "@datanac/datanac-api-toolkit/dist/utility/InsurancePlanHelper";

export const BUDGET_STATUS_ACTIVE = "active";
export const BUDGET_STATUS_DRAFT = "draft";

export const BUDGET_CATEGORY_DIRECT = "direct";
export const BUDGET_CATEGORY_INDIRECT = "indirect";

export const getBudgetYears = () => {
  const reinsuranceYear = getCurrentReinsuranceYear();
  return [
    reinsuranceYear - 5,
    reinsuranceYear - 4,
    reinsuranceYear - 3,
    reinsuranceYear - 2,
    reinsuranceYear - 1,
    reinsuranceYear,
    reinsuranceYear + 1,
    reinsuranceYear + 2,
  ];
};

export const getHistoryYears = () => {
  const reinsuranceYear = getCurrentReinsuranceYear();
  return [
    reinsuranceYear - 4,
    reinsuranceYear - 3,
    reinsuranceYear - 2,
    reinsuranceYear - 1,
    reinsuranceYear,
    reinsuranceYear + 1,
    reinsuranceYear + 2,
  ];
};

export {
  BUDGET_COST_DEFAULTS,
  BUDGET_ITEMS_DIRECT,
  BUDGET_ITEMS_INDIRECT,
  BUDGET_LINEITEM_NAME_INTEREST,
  BUDGET_LINEITEMS,
  budgetLineItemKey,
  budgetLineItemLabel,
  budgetLineItemStoredName,
} from "./budgetLineItems.js";

export const UNIT_OF_MEASURE_NAMES = ["gal", "oz", "lb", "kg", "ton", "each", "bag"];
